import React, { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { checkAuth } from '../services/AuthService';
// PAGES
import LoginPage from '../pages/LoginPage';
import SignupPage from '../pages/SignupPage';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import ConfirmUser from '../pages/ConfirmUser';
import UseTerms from '../pages/UseTerms';
import Home from '../pages/Home';
import FAQ from '../pages/FAQ';
import Contact from '../pages/Contact';
import NewOS from '../pages/NewOS';
import ListOS from '../pages/ListOS';
import ListUsers from '../pages/ListUsers';
import RelatorioOS from '../pages/RelatorioOS';
import RelatorioDetalhadoOS from '../pages/RelatorioDetalhadoOS';
import Relato from '../pages/Relato';
import Config from '../pages/Config';
import Edit from '../pages/EditOS';
import ModulesPage from '../pages/ModulesPage';
import NotificationPage from '../pages/NotificationPage';
import FinancialDashboard from '../pages/FinancialDashboard';
import FinancialPage from '../pages/Financial';

const PrivateRoute: FC<{ component: React.ComponentType<any>; allow: string[] }> = ({
  component: Component,
  allow,
}) => {
  const auth = checkAuth(allow);

  return auth ? <Component /> : <Navigate to="/login" />;
};

const permissao = {
  nivel_0: ['admin', 'manager', 'team member', 'sindicante'],
  nivel_1: ['admin', 'manager', 'sindicante'],
  nivel_2: ['admin', 'manager'],
  nivel_3: ['admin'],
  nivel_4: ['admin_sd'],
};

const AppRoutes: FC = () => (
  <Routes>
    <Route path="/" element={<LoginPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/cadastro" element={<SignupPage />} />
    <Route path="/recuperar" element={<ForgotPassword />} />
    <Route path="/resetarSenha" element={<ResetPassword />} />
    <Route path="/confirmacao" element={<ConfirmUser />} />
    <Route path="/termos" element={<UseTerms />} />

    <Route path="/home" element={<PrivateRoute component={Home} allow={permissao.nivel_0} />} />
    <Route path="/FAQ" element={<PrivateRoute component={FAQ} allow={permissao.nivel_0} />} />
    <Route path="/contato" element={<PrivateRoute component={Contact} allow={permissao.nivel_0} />} />
    <Route path="/configuracoes" element={<PrivateRoute component={Config} allow={permissao.nivel_0} />} />
    <Route path="/nova-sindicancia-sinistro" element={<PrivateRoute component={NewOS} allow={permissao.nivel_0} />} />
    <Route path="/lista-os" element={<PrivateRoute component={ListOS} allow={permissao.nivel_0} />} />
    <Route path="/lista-usuarios" element={<PrivateRoute component={ListUsers} allow={permissao.nivel_2} />} />
    <Route path="/relatorio-os" element={<PrivateRoute component={RelatorioOS} allow={permissao.nivel_2} />} />
    <Route path="/relatorio-detalhado-os" element={<PrivateRoute component={RelatorioDetalhadoOS} allow={permissao.nivel_2} />} />
    <Route path="/relato/:id" element={<PrivateRoute component={Relato} allow={permissao.nivel_0} />} />
    <Route path="/editar/:id" element={<PrivateRoute component={Edit} allow={permissao.nivel_0} />} />
    <Route path="/modulos" element={<PrivateRoute component={ModulesPage} allow={permissao.nivel_0} />} />
    <Route path="/notificacoes" element={<PrivateRoute component={NotificationPage} allow={['block']} />} />
    <Route path="/financeiro" element={<PrivateRoute component={FinancialPage} allow={permissao.nivel_1} />} />
    <Route path="/controle-financeiro" element={<PrivateRoute component={FinancialDashboard} allow={['block']} />} />

    <Route path="*" element={<LoginPage />} />
  </Routes>
);

export default AppRoutes;
